/* eslint-disable */
(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'DashboardKarcherTechnologyController',
      dashboardKarcherTechnologyController
    );

  /** @ngInject */
  function dashboardKarcherTechnologyController(
    dashboardKarcherActions,
    $timeout,
    $state,
    DashboardKarcherTechnologyViewModel,
    dispatcher,
    ActionTypesEnum,
    $translate,
    $log
  ) {
    // alarmsStore need to be imported for init reasons (don't remove)
    var vm = this;
    var map = null;
    var prevInfoWindow = null;
    var listOfAvailableSites = [];

    vm.dashboardKarcherTechnologyVM = new DashboardKarcherTechnologyViewModel();

    vm.searchSites = function () {
      settingMap(
        vm.dashboardKarcherTechnologyVM.siteName,
        vm.dashboardKarcherTechnologyVM.alarmStatus
      );
    };

    vm.getAlarm = function (site, facility, faultStatus) {
      dispatcher.dispatch({
        type: ActionTypesEnum.GET_ALARM_FROM_DASHBOARD_MESSAGE,
        payload: {
          from: 1262304001000,
          site: '',
          facility: facility ? facility.facilityId : '',
          faultStatus: faultStatus ? faultStatus : ''
        }
      });
      $state.go('app.alarms');
    };

    vm.returnToInitMap = function () {
      initMap();
    };

    function initMap() {
      settingMap('', []);
    }
    window.initMap = initMap;

    function setMarkerIcon(statusOfMarker) {
      switch (statusOfMarker) {
        case 'INFO':
          return 'assets/icons/ic_pin_green.svg';
        case 'WARNING':
          return 'assets/icons/ic_pin_yellow.svg';
        case 'ALARM':
          return 'assets/icons/ic_pin_red.svg';
        default:
          return 'assets/icons/ic_pin_green.svg';
      }
    }

    function closeMarker() {
      $timeout(function () {
        vm.dashboardKarcherTechnologyVM.refreshFacilityAlarmStatuses({
          facilityAlarmStatuses: []
        });
      }, 0);
    }

    function loadScript(url, callback) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;

      script.onload = callback;
      script.onerror = function () {
        console.error('Failed to load script:', url);
      };

      document.head.appendChild(script);
    }

    function settingMap(siteName, alarmStatus) {
      loadScript(
        'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js',
        function () {
          $log.log('MarkerClusterer loaded successfully!');
          var bounds = new google.maps.LatLngBounds();

          dashboardKarcherActions
            .getKarcherSitesData(siteName, alarmStatus)
            .then(function (response) {
              response.siteAlarmStatusDtos.forEach(function (site) {
                listOfAvailableSites.push(site.siteId);
              });
              vm.dashboardKarcherTechnologyVM.refreshAlarmsOnMapPage(response);
              if (response.siteAlarmStatusDtos.length === 0) {
                navigator.geolocation.getCurrentPosition(showPosition);
              } else {
                map = new google.maps.Map(document.getElementById('map'), {
                  center: {
                    lat: response.siteAlarmStatusDtos[0].latitude,
                    lng: response.siteAlarmStatusDtos[0].longitude
                  },
                  styles: vm.dashboardKarcherTechnologyVM.mapStyleSelector
                    ? vm.dashboardKarcherTechnologyVM.mapStyles
                    : null
                });

                // Map zoom options
                map.setOptions({
                  draggable: true,
                  zoomControl: true,
                  scrollwheel: true,
                  disableDoubleClickZoom: true
                });
              }

              function showPosition(position) {
                new google.maps.Map(document.getElementById('map'), {
                  zoom: 13,
                  center: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                  }
                });
                // dispatch message
                dispatcher.dispatch({
                  type: ActionTypesEnum.SHOW_TOASTER_MSG,
                  payload: {
                    type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                    message: $translate.instant('NO_FACILITIES_NEARBY')
                  }
                });
              }

              var markerArray = [];

              response.siteAlarmStatusDtos.forEach(function (marker) {
                if (marker.latitude === 0 || marker.longitude === 0) {
                  return;
                }

                var markerIn = new google.maps.Marker({
                  position: {
                    lat: marker.latitude,
                    lng: marker.longitude
                  },
                  map: map,
                  title: marker.siteName,
                  icon: setMarkerIcon(marker.status)
                });

                markerArray.push(markerIn);

                bounds.extend(markerIn.getPosition());

                var infowindow = new google.maps.InfoWindow();
                var content = '';

                google.maps.event.addListener(
                  infowindow,
                  'closeclick',
                  closeMarker
                );

                google.maps.event.addListener(
                  markerIn,
                  'click',
                  (function (markerIn, content, infowindow) {
                    return function () {
                      dashboardKarcherActions
                        .getKarcherSitesInfoWindowData(marker.siteId)
                        .then(function (siteData) {
                          if (prevInfoWindow) {
                            prevInfoWindow.close();
                          }
                          vm.dashboardKarcherTechnologyVM.refreshFacilityAlarmStatuses(
                            siteData
                          );
                          content =
                            "<div class='paddingAll10'>" +
                            "<div style='display: inline-flex; border-bottom: 1px solid #9E9E9E; padding: 0 0 10px 0; width: 100%;'>" +
                            "<img style='height: 30px; margin-top: 7px' src='" +
                            setMarkerIcon(marker.status) +
                            "'>" +
                            "<h3 style='padding-left: 10px'>" +
                            siteData.site.name +
                            '</h3></div>' +
                            "<p class='info-map-description' style='margin-top: 20px'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.address +
                            ': </span>' +
                            siteData.site.address +
                            '</p>' +
                            "<p class='info-map-description' style='margin-top: 20px'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.info +
                            ': </span>' +
                            siteData.site.info +
                            '</p>' +
                            "<p class='info-map-description marginTop20'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.phone +
                            ': </span>' +
                            siteData.site.phone1 +
                            ', ' +
                            siteData.site.phone2 +
                            '</p>' +
                            "<p class='info-map-description marginBottom20 marginTop20'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.workingHours +
                            ': </span>' +
                            siteData.workingDay.hoursFrom +
                            ' - ' +
                            siteData.workingDay.hoursTo +
                            '</p>' +
                            "<button id='infoButton-map-details' class='info-map-button'>" +
                            vm.dashboardKarcherTechnologyVM
                              .buttonTitleOnMapModal +
                            '</button>' +
                            '</div>';

                          prevInfoWindow = infowindow;
                          infowindow.setContent(content);
                          infowindow.open(map, markerIn);
                          $timeout(function () {
                            var mapDiv = document.getElementById(
                              'infoButton-map-details'
                            );
                            google.maps.event.addDomListener(
                              mapDiv,
                              'click',
                              function () {
                                infowindow.close();
                                $state.go(
                                  'app.dashboardTechnology.siteDetails',
                                  {
                                    id: siteData.site.pointId,
                                    siteAddress: decodeURIComponent(
                                      siteData.site.address
                                    ),
                                    siteLatitude:
                                      siteData.site.location.latitude,
                                    siteLongitude:
                                      siteData.site.location.longitude
                                  }
                                );
                              }
                            );
                          }, 0);
                        });
                    };
                  })(markerIn, content, infowindow)
                );
              });

              new markerClusterer.MarkerClusterer({
                map: map,
                markers: markerArray
              });

              map.fitBounds(bounds);
            });
        }
      );
    }
  }
})();
/* eslint-enable */
